const BASE = "https://static.prod-images.emergentagent.com/jobs/0c393ec1-3405-4eb1-be58-a2051533df5b/images";

export const BRAND_LOGOS = {
  havells: `${BASE}/e4f577e0f7e49bd3457f83a897c83877030dfe49e086afe1751351904b597a98.png`,
  legrand: `${BASE}/1ae1d585bab04004a38b4217de0217cdc14cda3d8d203d84997025cb84fd1d68.png`,
  abb: `${BASE}/8f46223cabe7a29d9f4c2a956fa2ed9c3fcea46cc53f813a27708d55fa21f845.png`,
  indoasian: `${BASE}/2af9bab0236ac09d488807ae6845fd925f5f0e2a9fa86df495469c47c912511a.png`,
  anchor: `${BASE}/c37a96181848038328ce56e479a9e274de59a30d769cfed930bc2806e72ad4a1.png`,
  schneider: `${BASE}/ca078d1c4c410e17ac18517b1fe2e5d84281cf627c47c2602767a87e2eb9c256.png`,
  polycab: `${BASE}/e424aed647d51e7f05d3b7baec6b93a8381223dc308e43dc352191031d01bc64.png`,
  finolex: `${BASE}/4fd2dc0f2cf33b30006fec7da833745a503461f4b563726b8b7e6c23c45f7735.png`,
  siemens: `${BASE}/dca5cc8dca648367991f2c15115265c67288b95a84dc72a1257e4039771b272c.png`,
  vguard: `${BASE}/266a865186fa6ebc41068ac2726e4709fad335db576240e891121933af94c9f9.png`,
};

export const brandLogo = (brand) =>
  BRAND_LOGOS[(brand || "").toLowerCase().replace(/[^a-z0-9]/g, "")] || null;
